module.exports = __webpack_public_path__ + "img/box3_img1_active.0a72e320.png";